import { mapValues } from 'lodash';
import { serverUserFieldsToUserFields } from 'state/combiners';
import { Dictionary } from 'ts-essentials';
import { ServerUserFields, UserFields } from 'type';

export const serverUserFieldsToUserFieldsCombiner = (
  serverUserFields: Dictionary<ServerUserFields>
): Dictionary<UserFields> =>
  mapValues(serverUserFields, serverUserFieldsToUserFields);
